import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'

export default function Project_insight() {
    const [selectProjectName, setSelectProjectName] = useState('');
    const [selectProjectId, setSelectProjectId] = useState('');
    const [listProjectTaskArray, setListProjectTaskArrayy] = useState([]);
    const [listProjectArray, setListProjectArray] = useState([]);
    const [showAlertBox, setShowAlertBox] = useState(false);
    const [listProjectMembersArray, setListProjectMembersArray] = useState([]);
    const [alertMsg, setAlertMsg] = useState("");
    const [selectedProDescription, setSelectedProDescription] = useState('');
    const [completeTask, setCompleteTask] = useState(0);
    const [activeTask, setActiveTask] = useState(0);
    const [pendingTask, setPendingTask] = useState(0);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [budgetStatus, setBudgetStatus] = useState({
        salary_complete: false,
        fixed_cost_complete: false,
        earn_complete: false,
        total_members: 0,
        members_with_salary: 0,
        missing_members: []
    });
    const [calculation, setCalculation] = useState(null);
    const [budgetConsumed, setBudgetConsumed] = useState(0);
    const [budgetBarColor, setBudgetBarColor] = useState('#16a34a');
    const [listProjecttimeArray, setListProjecttimeArray] = useState([]);
    const [totalTime, setTotalTime] = useState(0);
    const [formattedTime, setFormattedTime] = useState('0h 0m');
    const [listOfIssues, setListOfIssues] = useState([]);
    const [totalIssues, setTotalIssues] = useState(0);
    const [issueNotice, setIssueNotice] = useState('No issue found');
    const [membretype, setMembertype] = useState(false);

    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        var company_id = localStorage.getItem('mem_company_id');
        var obj = {
            companyId: company_id
        }
        $.ajax({
            type: 'POST',
            url: 'getAllProjects.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result);
                try {
                    const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListProjectArray(parsedResult);
                        setDropDown(parsedResult);
                    } else {
                        showAlert('No active projects found for your company.');
                        setListProjectArray([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load project data.');
                    setListProjectArray([]); // fallback to prevent map crash
                }
            },
        });
    }, [])

    function setDropDown(parsedResult) {
        const select = document.getElementById("allprojects");
        // Clear old options except "All"
        select.length = 1;
        parsedResult.forEach(project => {
            const option = document.createElement("option");
            option.value = project.primary_key;
            option.textContent = project.pro_name;
            select.appendChild(option);
        });
    }
    const callFatchrecord = () => {
        let proid = document.getElementById('allprojects').value;
        let select = document.getElementById('allprojects');
        let proname = select.options[select.selectedIndex].text;
        setSelectProjectName(proname);
        setSelectProjectId(proid);
        getSelectedProjectDetails(proid);
        document.getElementById('pro_insight').style.display = "block";
    };

    function getSelectedProjectDetails(projectId) {
        const selectedProject = listProjectArray.find(project => project.primary_key == projectId);
        if (selectedProject) {
            setSelectedProDescription(selectedProject.pr_details);
            loadAllProjectMembers(projectId);
        } else {
            setSelectedProDescription('');
        }
    }

    function loadAllProjectMembers(projectId) {
        var obj = {
            pro_id: projectId
        };

        fetch('getAllProjectMember.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.json()) // same as your original (not JSON)
            .then(result => {
                console.log(result);
                var res = result;
                if (res !== 'fail' && res !== '') {
                    try {
                        var memarr = res;
                        // If your backend actually returns JSON string, then use this instead:
                        // var memarr = JSON.parse(res);
                        if (Array.isArray(memarr)) {
                            var len = memarr.length;
                            if (len < 1) {
                                document.getElementById('memnumnotice').innerText = 'Cannot find any active member for this project.';
                            } else {
                                setListProjectMembersArray(memarr);
                            }
                        } else {
                            setListProjectMembersArray([]);
                        }

                    } catch (e) {
                        console.error("Invalid JSON from backend:", e);
                        document.getElementById('memnumnotice').innerText = 'Cannot find any active member for this project.';
                        setListProjectMembersArray([]);
                    }
                } else {
                    showAlert('Cannot find any active member for this project.');
                    document.getElementById('memnumnotice').innerText = 'Cannot find any active member for this project.';
                    setListProjectMembersArray([]);
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
        loadtasks(projectId)
    }

    function loadtasks(proid) {
        console.log(proid)
        var obj = {
            pro_id: proid
        }

        $.ajax({
            type: 'POST',
            url: 'getAllProjectTasks.php',
            data: obj,
            cache: false,
            success: function (result) {
                var res = result;
                console.log(res);
                if (res !== 'fail' && res !== '') {
                    var arr = res;
                    var len = arr.length ? arr.length : '0';
                    if (len < 1) {
                        document.getElementById('norecord').style.display = 'block';
                    } else {
                        setListProjectTaskArrayy(arr);
                        const completeCount = arr.filter(
                            task => task.tsk_status === 'complete'
                        ).length;
                        const activeCount = arr.filter(
                            task => task.tsk_status === 'active'
                        ).length;
                        const pendingCount = arr.filter(
                            task => task.tsk_status === 'pending'
                        ).length;

                        // Save in state
                        setCompleteTask(completeCount);
                        setActiveTask(activeCount);
                        setPendingTask(pendingCount);
                    }


                } else {
                    document.getElementById('norecord').style.display = 'block';
                }
            },
        });
        loadBudgetStatus(proid);
        fetchCalculation(proid);
    }


    function loadBudgetStatus(proid) {
        const project_id = proid;
        const company_id = localStorage.getItem('mem_company_id');
        fetch(
            `check_budget_status.php?company_id=${company_id}&project_id=${project_id}`
        )
            .then(res => res.json())
            .then(data => {
                console.log("Budget Status:", data);
                setBudgetStatus(data);
            })
            .catch(err => console.error(err));
    }

    function fetchCalculation(proid) {
        const project_id = proid;
        const company_id = localStorage.getItem('mem_company_id');
        fetch(
            `calculate_budget.php?project_id=${project_id}&company_id=${company_id}`
        )
            .then(res => res.json())
            .then(data => {
                console.log("Calculation:", data);
                setCalculation(data);
                // Calculate consumed percentage
                if (data.earn > 0) {
                    const consumed = (
                        (data.total_cost / data.earn) * 100
                    ).toFixed(0);
                    setBudgetConsumed(consumed);                // Dynamic bar color
                    if (consumed > 85) {
                        setBudgetBarColor('#dc2626');
                    } else if (consumed > 60) {
                        setBudgetBarColor('#f59e0b');
                    } else {
                        setBudgetBarColor('#16a34a');
                    }
                }
            })
            .catch(err => console.error(err));

        loadProjectTimeTracking(proid);
    }

    function loadProjectTimeTracking(projectId) {
        fetch('getAllProjectTime.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                pro_id: projectId
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (Array.isArray(data) && data.length > 0) {
                    setListProjecttimeArray(data);
                    let totalSeconds = 0;
                    data.forEach(item => {
                        totalSeconds += timeToSeconds(
                            item.time_worked
                        );
                    });
                    setTotalTime(totalSeconds);
                    setFormattedTime(
                        formatTotalTime(totalSeconds)
                    );
                } else {
                    setListProjecttimeArray([]);
                    setTotalTime(0);
                    setFormattedTime('0h 0m');
                }
            })
            .catch(err => {
                console.error("Fetch Error:", err);
            });

        loadIssues(projectId)
    }


    function loadIssues(proid) {
        const company_id = localStorage.getItem('mem_company_id');
        const obj = {
            pro_id: proid,
            com_id: company_id
        };
        fetch('getAllProjectIssue.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(res => res.json())
            .then(data => {
                const issues = data || [];
                setListOfIssues(issues);
                const issueCount = issues.length;
                setTotalIssues(issueCount);
                // Set notice text
                if (issueCount > 0) {
                    setIssueNotice(
                        `${issueCount} issue${issueCount > 1 ? 's' : ''} found`
                    );
                } else {
                    setIssueNotice('No issue found');
                }
            })
            .catch(err => {
                console.log(err);
                setTotalIssues(0);
                setIssueNotice('Failed to load issues');
            });
    }

    function showAlert(msg) {
        setAlertMsg(msg);
        setShowAlertBox(true);
    }

    function closeAlert() {
        setAlertMsg('');
        setShowAlertBox(false);
    }
    function isBudgetDataComplete() {
        return (
            budgetStatus.salary_complete &&
            budgetStatus.fixed_cost_complete &&
            budgetStatus.earn_complete
        );
    }

    function getMissingBudgetMessages() {
        let messages = [];
        if (!budgetStatus.salary_complete) {
            messages.push(
                `${budgetStatus.total_members - budgetStatus.members_with_salary
                } member salary missing`
            );
        }
        if (!budgetStatus.fixed_cost_complete) {
            messages.push('Fixed cost not added');
        }
        if (!budgetStatus.earn_complete) {
            messages.push('Project earn amount missing');
        }
        return messages;
    }

    function timeToSeconds(time) {
        const parts = time.split(':');
        const hours = parseInt(parts[0]) || 0;
        const minutes = parseInt(parts[1]) || 0;
        const seconds = parseInt(parts[2]) || 0;
        return (hours * 3600) + (minutes * 60) + seconds;
    }

    function formatTotalTime(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        return `${hrs}h ${mins}m`;
    }

    const totalTasks = completeTask + activeTask + pendingTask;

    const completeWidth = totalTasks > 0 ? (completeTask / totalTasks) * 100 : 0;

    const activeWidth = totalTasks > 0 ? (activeTask / totalTasks) * 100 : 0;

    const pendingWidth = totalTasks > 0 ? (pendingTask / totalTasks) * 100 : 0;

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Project Insight</h2>
                    <div className='fullwidth pull_left pt_20 projectlist_drop'>
                        <p>Select a project from the list below</p>
                        <select id="allprojects" onChange={callFatchrecord}>
                            <option value="">Select a project</option>
                        </select>
                    </div>
                    <div className='fullwidth pull_left pt_20'>
                        <h3 className='vl_dsh_pop_content_heading'>{selectProjectName}</h3>
                    </div>
                </div>
                <div className='nodisplay fullwidth pull_left' id="pro_insight">
                    <div className='fullwidth pull_left pt_40'>
                        <h3 className='vl_dsh_pop_content_heading'>Project Description</h3>
                        <p>{selectedProDescription}</p>
                    </div>
                    <div className='fullwidth pull_left pt_40'>
                        <h3 className='vl_dsh_pop_content_heading'>Project Members</h3>
                        <p id="memnumnotice"></p>
                        {Array.isArray(listProjectMembersArray) && listProjectMembersArray.map((item, index) => {
                            return (
                                <div className='vl_listing_row'>
                                    <div className='vl_listing_cell width25' key={index}>
                                        <h4 className='prj_name'>{item.membername}</h4>
                                        <span>Role : {item.member_role}</span>
                                        <span>Project name : {item.proname}</span>
                                        <span>Status : {item.status_member}</span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className='fullwidth pull_left pt_40'>
                        <h3 className='vl_dsh_pop_content_heading'>Project Overview</h3>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_half'>
                                <div className='cardwide'>
                                    <h2>Completion</h2>
                                    <p>Project Progress</p>
                                    <p className='hint progress_percent'>Completed {completeWidth}%</p>
                                    <div className='progress_bar_holder'>
                                        <div className='progress_bar project_progress' style={{ width: `${completeWidth}%` }}>&nbsp;</div>
                                    </div>
                                    <p className='completed_task'>Completed tasks: {completeTask} task</p>
                                    <p className='completed_task'>Total tasks: {totalTasks} task</p>
                                </div>
                            </div>
                            <div className='vl_dsh_one_half'>
                                <div className='cardwide'>
                                    <h2>Budget</h2>
                                    {isBudgetDataComplete() && calculation ? (
                                        <>
                                            <p>Budget Used</p>
                                            <p className='hint project_budget'>
                                                {calculation.total_cost}
                                                /
                                                {calculation.earn}
                                            </p>
                                            <div className='budget_progress_holder'>
                                                <div
                                                    className='budget_progress_bar'
                                                    style={{ width: `${budgetConsumed}%` }}>
                                                </div>

                                            </div>
                                            <p className='budget_consumed'>
                                                {budgetConsumed}% consumed
                                            </p>
                                            <p className='smalltext'>Consumed % will not show below 1%</p>
                                            <p className='budget_profit_text'>
                                                {calculation.profit >= 0
                                                    ? `Profit ${calculation.profit}`
                                                    : `Loss ${Math.abs(calculation.profit)}`
                                                }
                                            </p>
                                        </>
                                    ) : (
                                        <div className='budget_warning_box'>
                                            <p className='budget_warning_heading'>
                                                Budget data incomplete
                                            </p>
                                            {
                                                getMissingBudgetMessages().map((msg, index) => (
                                                    <p key={index} className='budget_warning_text'>
                                                        • {msg}
                                                    </p>
                                                ))
                                            }
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_half'>
                                <div className='cardwide'>
                                    <h2>Time Tracking</h2>
                                    <p>Time Spent</p>
                                    <p className='hint project_time'>{formattedTime}</p>
                                    <p>Here we are calculating the time as per the time you traced by the time tracker tool. </p>

                                </div>
                            </div>

                            <div className='vl_dsh_one_half'>
                                <div className='cardwide'>
                                    <h2>Open Issues</h2>
                                    <p>Open Issues</p>
                                    <p className='hint project_issue'>{totalIssues}</p>
                                    <p id="noticetext">{issueNotice}</p>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='fullwidth pull_left pt_40'>
                        <h3 className='vl_dsh_pop_content_heading'>Task Progress</h3>
                        <div className='progress_view'>
                            <div className='vl_listing_row nodisplay' id="norecord">
                                <h1 className='notice_text'> No Record Found</h1>
                            </div>
                            <div className='progress_task_section'>
                                <div className='progress_bar_holder task_bar'>
                                    <div
                                        className='progress_bar complete_task_number'
                                        style={{ width: `${completeWidth}%` }}>
                                        &nbsp;
                                    </div>
                                </div>
                                <p className='number_complete_task'>
                                    {completeTask} task completed
                                </p>
                            </div>
                            <div className='progress_task_section'>
                                <div className='progress_bar_holder task_bar'>
                                    <div
                                        className='progress_bar active_task_number' style={{ width: `${activeWidth}%` }} >
                                        &nbsp;
                                    </div>
                                </div>
                                <p className='number_active_task'>
                                    {activeTask} task in progress
                                </p>
                            </div>
                            <div className='progress_task_section'>
                                <div className='progress_bar_holder task_bar'>
                                    <div
                                        className='progress_bar pending_task_number'
                                        style={{ width: `${pendingWidth}%` }}
                                    >
                                        &nbsp;
                                    </div>
                                </div>
                                <p className='number_pending_task'>
                                    {pendingTask} task pending
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            {showAlertBox && (
                <div className='vl_dsh_popup_vis'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>
                        <div className='contentarea'>
                            <p>{alertMsg}</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={closeAlert}>Okay</button>
                        </div>
                    </div>
                </div>
            )}

            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
